
import { useEffect, useState } from 'react';

interface LoadingScreenProps {
  onLoadingComplete: () => void;
}

export default function LoadingScreen({ onLoadingComplete }: LoadingScreenProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            onLoadingComplete();
          }, 300);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 100);

    return () => clearInterval(timer);
  }, [onLoadingComplete]);

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
      {/* Logo */}
      <div className="flex items-center space-x-2 mb-8">
        <div className="w-8 h-8 rounded-lg overflow-hidden">
          <img 
            src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f21c56093101f07d70e4f03bb9372588.png" 
            alt="狮虎堂 Logo" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex flex-col">
          <span className="text-lg font-bold text-[#2f3673]" style={{ fontFamily: '"Pacifico", serif' }}>狮虎堂</span>
          <span className="text-xs text-gray-500">LIONTIGER HUB</span>
        </div>
      </div>

      {/* Loading Animation */}
      <div className="relative">
        <div className="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin border-t-[#f7931d]"></div>
      </div>

      {/* Loading Text */}
      <p className="text-sm text-gray-600 mt-6 animate-pulse">正在唤醒狮虎之力...</p>

      {/* Progress Bar */}
      <div className="w-48 h-1 bg-gray-200 rounded-full mt-4 overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-[#f7931d] to-[#2f3673] transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      {/* Progress Percentage */}
      <span className="text-xs text-gray-500 mt-2">{Math.round(progress)}%</span>
    </div>
  );
}